import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BONOS, BONOS_IMAGE } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-ivory py-14 sm:py-24" aria-labelledby="bonos-title" data-id="element-26" data-mp="13cw28rl9uqe4">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-27" data-mp="yfmcfatz0cpr">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-28" data-mp="tfq9zg0x8tcb">
          <div className="lg:col-span-7" data-id="element-29" data-mp="tdnam5dvpnux">
            <SectionTag data-id="element-30" data-mp="og59v2a0mey0">Bonos incluidos</SectionTag>
            <h2 id="bonos-title" className="mt-4 font-display text-[1.6rem] uppercase leading-[1.06] text-charcoal sm:text-[2.5rem]" data-id="element-31" data-mp="ofc15vrhxfd8">
              Y además te llevás 5 bonos de implementación
            </h2>
            <p className="mt-4 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/65 sm:text-base" data-id="element-32" data-mp="2etm98cxirm8s">
              No son regalos de relleno: son las piezas que hacen que el sistema quede funcionando en
              tu consultorio, no guardado en una carpeta.
            </p>
          </div>

          <div className="lg:col-span-5" data-id="element-33" data-mp="vur8osc6lzhq">
            <img src={BONOS_IMAGE} alt="Los 5 bonos de implementación presentados como una colección de guías digitales." loading="lazy" decoding="async" className="w-full rounded-3xl border border-warm object-cover shadow-[0_24px_50px_-32px_rgba(34,34,34,0.45)]" data-id="element-34" data-mp="vvsiyuldihye" />
          </div>
        </div>

        <ul className="mt-10 grid gap-4 sm:mt-14 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3" data-id="element-35" data-mp="1ejp927y32tky">
          {BONOS.map((bono, index) => <motion.li key={bono.number} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(index, 2) * 0.05
        }} className={`flex h-full flex-col rounded-3xl border border-gold/30 bg-bone p-5 shadow-[0_18px_40px_-34px_rgba(34,34,34,0.5)] transition-transform duration-200 ease-out hover:-translate-y-1 sm:p-6 ${index === 4 ? 'sm:col-span-2 lg:col-span-1' : ''}`} data-id="element-36" data-mp="10rrgp8sldcbh" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-37" data-mp="1t7fsz4v8r5lq">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold" aria-hidden data-id="element-38" data-mp="1p6cdijh3vbl1">
                  <GiftIcon className="h-4 w-4 text-charcoal" data-id="element-39" data-mp="1kdj6foy5zr5s" />
                </span>
                <span className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-40" data-mp="1fe6nhfaez48h">
                  Bono {bono.number}
                </span>
              </div>

              <h3 className="mt-4 font-display text-[1.02rem] uppercase leading-tight text-charcoal sm:text-[1.15rem]" data-id="element-41" data-mp="15hbneryhsvs3">
                {bono.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.8rem] font-semibold text-gold-deep sm:text-[0.86rem]" data-id="element-42" data-mp="3d2tpo8f7ou4y">
                {bono.subtitle}
              </p>
              <p className="mt-3 font-sans text-[0.85rem] leading-relaxed text-charcoal/65" data-id="element-43" data-mp="3m4jpa1j8yzdt">
                {bono.body}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}